module.exports = __webpack_public_path__ + "img/sv31.13038843.svg";